import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
    List, ListItem, ListItemText, ListItemAvatar, Avatar,
} from '@material-ui/core';

// Ejemplo de objeto a iterar
/* {
    title: 'Titulo que se quiera mostarr (No obligatorio )',
    message: 'Mensaje de lista como subtitulo',
    icon: <SecurityIcon />,
}, */

// Estilos
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

const ListComponentBase = ({ items }) => {
    const classes = useStyles();

    return (
      <List className={classes.root}>
        {items.map((item, index) => (
          <ListItem key={`List-${index + 1}`}>
            <ListItemAvatar>
              <Avatar>
                {item.icon}
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={item.title} secondary={item.message} />
          </ListItem>
          ))}
      </List>
    );
};

ListComponentBase.propTypes = {
    // Array de items a mostrar en la lista
    // este array debe tener ( titulo, mensaje,icono ) ver ejemplo arriba
    items: PropTypes.oneOfType([PropTypes.array]).isRequired,
};

export default ListComponentBase;
